import React from 'react';

const CTASection = () => {
  return (
    <section className="cta cta-trainer-background">
      <div className="container">
        <h2>Try now!</h2>
        <div className="cta-button-container">
          <a 
            href="https://apps.apple.com/us/app/gto-preflop/id1629141961" 
            className="cta-button" 
            id="main-cta-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download for any device
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection; 